import React from "react";
import { Seo } from "../components/Seo";
import { useI18n } from "../i18n/I18nContext";
import { PoseEagle } from "../components/PoseEagle";
import { Band } from "../components/Band";

export default function AboutPage() {
  const { t } = useI18n();
  return (
    <main className="pt-40 lg:pt-36 pb-16" data-testid="about-page">
      <Seo k="about" />
      <Band tone="dark" className="pb-10">
        <div className="max-w-5xl mx-auto px-6 lg:px-10">
          <div className="grid lg:grid-cols-12 gap-10 lg:gap-12 items-center">
          <div className="lg:col-span-7">
            <div className="eyebrow mb-3">{t.nav.about}</div>
            <div className="flex flex-col sm:flex-row sm:items-end gap-6">
              <div>
                <h1 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl text-white tracking-tighter">{t.aboutPage.title}</h1>
                <p className="text-slate-300 mt-6 text-xl leading-relaxed font-medium">{t.aboutPage.lead}</p>
              </div>
              <PoseEagle
                src="/eagle-poses/eagle-about-proud.png"
                size={215}
                mobileSize={115}
                entrance="proud"
                testid="about-eagle"
                className="shrink-0 self-center sm:self-end"
              />
            </div>
          </div>

          <div className="lg:col-span-5">
            <div
              className="relative rounded-3xl border border-white/10 overflow-hidden px-8 pt-10 pb-7"
              data-testid="about-brand-card"
              style={{
                background:
                  "radial-gradient(circle at 50% 38%, rgba(226,236,255,0.95) 0%, rgba(190,210,245,0.75) 30%, rgba(110,150,215,0.28) 52%, rgba(6,11,25,0) 74%), #0B1228",
              }}
            >
              <div className="text-center text-[10px] tracking-[0.2em] font-mono font-bold text-slate-900/70 mb-3">{t.aboutPage.brandLabel}</div>
              <img
                src="/brand/tp-agency-logo.png"
                alt={t.aboutPage.brandAlt}
                data-testid="about-original-logo"
                className="mx-auto w-52 sm:w-60 h-auto select-none"
                draggable="false"
              />
              <div className="mt-7 pt-5 border-t border-white/10 flex items-start gap-3">
                <img src="/eagle.png" alt="TP Agency eagle mascot" className="w-10 h-10 shrink-0 rounded-lg bg-white/5 border border-white/10 p-1" />
                <p className="text-xs text-slate-400 leading-relaxed" data-testid="about-brand-note">{t.aboutPage.brandNote}</p>
              </div>
            </div>
          </div>
        </div>
        </div>
      </Band>

      <Band tone="light" className="pt-14 pb-4">
        <div className="max-w-5xl mx-auto px-6 lg:px-10">
        <div className="prose prose-invert max-w-none space-y-5 text-slate-300 leading-relaxed">
          {t.aboutPage.paragraphs.map((p) => (
            <p key={p.slice(0, 40)}>{p}</p>
          ))}
        </div>

        <div className="mt-12 grid md:grid-cols-3 gap-3">
          {t.aboutPage.values.map((v, i) => (
            <div key={i} className="glass rounded-2xl p-6" data-testid={`about-value-${i}`}>
              <div className="text-cyan-300 font-mono text-xs tracking-widest font-bold mb-3">{String(i + 1).padStart(2, "0")}</div>
              <div className="font-semibold text-white text-lg">{v.title}</div>
              <p className="text-slate-400 text-sm mt-2 leading-relaxed">{v.desc}</p>
            </div>
          ))}
        </div>
        </div>
      </Band>
    </main>
  );
}
